import { render, staticRenderFns } from "./FRegister.vue?vue&type=template&id=1dda091c&scoped=true&"
import script from "./FRegister.vue?vue&type=script&lang=js&"
export * from "./FRegister.vue?vue&type=script&lang=js&"
import style0 from "./FRegister.vue?vue&type=style&index=0&id=1dda091c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dda091c",
  null
  
)

export default component.exports